import React, { useReducer } from 'react';
import EvaluationContext from './evaluationContext';
import EvaluationReducer from './evaluationReducer'
import axiosClient from '../../config/axiosClient'

import {
    REGISTRO_ERROR,
    ACTIVAR_CUESTIONARIO,
    //CONSULTAR_CUESTIONARIO,
    OBTENER_FORMULARIOS,
    CONSULTAR_EVALUACION,
    GUARDAR_EVALUACION,
    OBTENER_EVALUACIONES,
    RECORRER_EVALUACIONES,
    ASIGNAR_FORMULARIO
} from "../../types";

const EvaluationState = (props) => {
    const initialState = {
        formularios: [],
        formulario: null,
        matchedId: null,
        evaluacion: null,
        evaluaciones: [],
        msg: null,
        cargando: null
    }
    
    const [ state, dispatch ] = useReducer(EvaluationReducer, initialState);

    const guardarEvaluacion = async datos => {
        try {
            const respuesta = await axiosClient.post('/api/evaluation/', datos);
            //console.log(datos)
            dispatch({
                type: GUARDAR_EVALUACION,
                payload: respuesta.data.evaluation
            });
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const obtenerFormularios = async () => {
        try {
            const respuesta = await axiosClient.get('/api/evaluation');

            dispatch({
                type: OBTENER_FORMULARIOS,
                payload: respuesta.data.form
            });
            consultarEvaluacion();
        } catch (error) {
            const alerta = {
                msg: "No fue posible obtener un formulario para realizar la evaluacion",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const asignarFormulario = (data) => {
        try {
            /* console.log('asingnando data en context')
            console.log(data) */
            dispatch({
                type: ASIGNAR_FORMULARIO,
                payload: data
            })
        } catch (error) {
            console.log(error)
        }
    }

    const consultarFormularios = async () => {
        try {
            const respuesta = await axiosClient.get('/api/evaluation/getAllForms');

            dispatch({
                type: OBTENER_FORMULARIOS,
                payload: respuesta.data.form
            });
            //consultarEvaluacion();
        } catch (error) {
            const alerta = {
                msg: "No fue posible obtener los formularios para realizar la cpmfiguración",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const consultarEvaluacion = async (datos) => {
        try {
            const respuesta = await axiosClient.post('/api/evaluation/hasEvaluation', datos);
            //console.log(state.formulario)
            dispatch({
                type: CONSULTAR_EVALUACION,
                payload: respuesta.data.evaluation
            });
        } catch (error) {
            const alerta = {
                msg: "No fue posible obtener una evaluacion",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const activarCuestionario = async datos => {
        try {
            //console.log(datos);
            const respuesta = await axiosClient.post('/api/evaluation/enable', datos);
            dispatch({
                type: ACTIVAR_CUESTIONARIO,
                payload: respuesta.data.form
            });
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const obtenerEvaluaciones = async (id) => {
        try {
            const respuesta = await axiosClient.get('api/evaluation/getEvaluations/' + id);
            dispatch({
                type: OBTENER_EVALUACIONES,
                payload: respuesta.data.evaluacionesConForm
            })
            //console.log(respuesta)
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const recorrerEvaluaciones = async (evaluacionN) => {
        try {
            dispatch({
                type: RECORRER_EVALUACIONES,
                payload: evaluacionN
            })
        } catch (error) {
            const alerta = {
                msg: 'No se pudieron recorrer las evaluaciones realizadas',
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }

    }

    return (
        <EvaluationContext.Provider
            value={{
                formularios: state.formularios,
                formulario: state.formulario,
                matchedId: state.matchedId,
                evaluacion: state.evaluacion,
                evaluaciones: state.evaluaciones,
                msg: state.msg,
                cargando: state.cargando,
                guardarEvaluacion,
                obtenerFormularios,
                asignarFormulario,
                consultarEvaluacion,
                consultarFormularios,
                activarCuestionario,
                obtenerEvaluaciones,
                recorrerEvaluaciones
            }}
        >{props.children}</EvaluationContext.Provider>
    );
}

export default EvaluationState;